import { useI18n } from "../../../i18n";
import { Goal } from "./ScenePanels";
import { EXCHANGE_GOAL, exchanged } from "../lib/radio";
import type { Plaza, RadioValue } from "../lib/radio";
import type { RadioStatus } from "../hooks/useMbRadio";

/**
 * 라디오 광장 판(PICNIC-MB-FIELD-001 §6 2단계) — 연결 상태 · 내 그룹 · 광장 친구(별명) · 오간 것(최근 12개) · 주고받기 목표.
 * 화면 문구는 DR-01 — 누가 더 많이 보냈는지 견주지 않는다(내 수만).
 */
/** members 는 나를 뺀 광장 친구(hooks/useMbRadio) */
export function RadioPanel({ status, members, plaza }: { status: RadioStatus; members: readonly { id: string; name: string }[]; plaza: Plaza }) {
  const { t } = useI18n();
  const show = (v: RadioValue) =>
    v.kind === "number" ? String(v.n) : v.kind === "string" ? `"${v.s}"` : v.kind === "value" ? `${v.name} = ${v.n}` : t("student.microbit.scene.plaza.other");
  const friends = members;
  return (
    <div className="pf-mb__scene" data-testid="fs-mb-scene-plaza">
      <p className="pf-mb__scene-state" data-testid="fs-mb-radio-status">{t(`student.microbit.scene.plaza.status.${status}`)}</p>
      <p className="pf-mb__scene-state" data-testid="fs-mb-radio-group">
        {plaza.group === null ? t("student.microbit.scene.plaza.noGroup") : t("student.microbit.scene.plaza.group", { g: plaza.group })}
      </p>
      <div className="pf-mb__row pf-mb__row--start" aria-label={t("student.microbit.scene.plaza.friends")}>
        {friends.length ? friends.map((m) => <span key={m.id} className="pf-mb__chip" data-on={plaza.partners.includes(m.name) || undefined}>📻 {m.name}</span>)
          : <span className="pf-mb__hint">{t("student.microbit.scene.plaza.alone")}</span>}
      </div>
      <ol className="pf-mb__radio-log" data-testid="fs-mb-radio-log">
        {plaza.log.map((e, i) => (
          <li key={i} data-dir={e.dir}>
            {e.dir === "out" ? t("student.microbit.scene.plaza.sent", { v: show(e.value), g: e.g }) : t("student.microbit.scene.plaza.got", { name: e.air ? `📡 ${e.name || t("student.microbit.gateway.board")}` : e.name || "?", v: show(e.value), g: e.g })}
          </li>
        ))}
      </ol>
      <p className="pf-mb__scene-state">{t("student.microbit.scene.plaza.count", { sent: plaza.sent, got: plaza.received })}</p>
      <Goal id="fs-mb-scene-goal" done={exchanged(plaza)} text={t("student.microbit.scene.plaza.goal", { goal: EXCHANGE_GOAL })} />
    </div>
  );
}
